import { useReinstallService } from './handlers/install'
import FormSegware from './Form/FormSegware'

export const SEGWARE = {
  key: 'segware',
  onReinstall: useReinstallService,
  Form: FormSegware,
  SCOPE: []
}

export default SEGWARE
